
    import '/mnt/src/components/DropDownMenu/index.md?watch=parent';
    export const demoIndex = {
  ids: ["dropdownmenu-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/DropDownMenu/index.md?type=demo')
};